import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { FormLabel } from '../form-label';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import { InputNumber } from 'antd';

const ProductStock = ({
  control,
  errors,
  productId,
}: {
  control: Control<CreateProductFormSchemaType>;
  errors: FieldErrors<CreateProductFormSchemaType>;
  productId?: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.OSoMXAfuDT)}:</FormLabel>
      <Controller
        name="stock"
        control={control}
        render={({ field }) => {
          return (
            <div className="w-full relative">
              <InputNumber
                disabled={!!productId}
                status={errors.stock ? 'error' : undefined}
                {...field}
                className="w-full"
                min={0}
                placeholder={i18n.t(LOCALS.please_enter) || ''}
              />
              {errors.stock && (
                <p style={{ color: 'red' }} className="absolute left-0">
                  {i18n.t(LOCALS.required_field)}
                </p>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default ProductStock;
